/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Validation_Incident_RequiredInputs */

const en_case_validation_incident_required = /** @type {(inputs: Case_Validation_Incident_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incident details are required.`)
};

const pt_br2_case_validation_incident_required = /** @type {(inputs: Case_Validation_Incident_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os dados do incidente são obrigatórios.`)
};

/**
* | output |
* | --- |
* | "Incident details are required." |
*
* @param {Case_Validation_Incident_RequiredInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_validation_incident_required = /** @type {((inputs?: Case_Validation_Incident_RequiredInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Validation_Incident_RequiredInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_validation_incident_required(inputs)
	return pt_br2_case_validation_incident_required(inputs)
});